import script from "./memberRoute.vue?vue&type=script&setup=true&lang=ts"
export * from "./memberRoute.vue?vue&type=script&setup=true&lang=ts"

import "./memberRoute.vue?vue&type=style&index=0&id=30b1de40&lang=css"

const __exports__ = script;

export default __exports__